import { effect, inject, signal, type WritableSignal } from '@angular/core';

import { LocalStorageService } from './local-storage.service';

export const localStorageSignal = <T>(key: string, defaultValue: T): WritableSignal<T> => {
  const lsService = inject(LocalStorageService);
  const sig = signal<T>(lsService.get(key, defaultValue));
  effect(() => lsService.set(key, sig()));
  return sig;
};
